import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  List,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { NavLink, useLocation } from "react-router-dom";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function SidebarItem({ 
  item, 
  openParent, 
  selectedId,
  setSelectedId,
  setOpenParent,  
  onToggle 
}) {
  
  const location = useLocation();
  const isSelected = location.pathname === item.href;
  
  const navigate = useNavigate();
  const hasChildren = item.children?.length > 0;

  const [open, setOpen] = useState(false);
  const isOpen = openParent === item.href;

   const handleClick = (item) => {
    if (hasChildren) {
      setOpenParent(prev => (prev === item.id ? null : item.id));

      setOpen(!open);
      onToggle(item.href);
  
      console.log('Parent: handleClick -> href:' + item.href);
    } 
    else {
      setSelectedId(item.href);
      navigate(item.href);

      console.log('Child: handleClick -> href:' + item.href);
    }
  };
 
  const childSelected = item.children?.some(child =>
    location.pathname.startsWith(child.href)
  );

  if (item.children) {                                  // hierarchical item
    return (
      <>
        <ListItemButton 
               onClick={() => handleClick(item)}         // combine setOpen(!open) and onToggle from Sidebar
               selected={childSelected}
          >
          <ListItemIcon><item.icon /></ListItemIcon>
          <ListItemText primary={item.title} />
          {isOpen && open ? <ExpandLess /> : <ExpandMore />}

        </ListItemButton>

        <Collapse in={isOpen && open} timeout="auto" unmountOnExit>
          <List disablePadding>
            {item.children.map((child, index) => (
                <ListItemButton
                      key={index}
                      component={NavLink}
                      to={child.href}
                      selected={location.pathname === child.href}
                      sx={{ pl: 4 }}
                    
                      onClick={() => {
                      setSelectedId(child.id);
                      navigate(child.href);
                      }}
                    >
                    <ListItemText primary={child.title}  sx={{ color: "#0d6efd" }}/>
                </ListItemButton>
            ))}
          </List>
        </Collapse>
      </>
    );
  }

  return (                                           // flat item
    <ListItemButton
          component={NavLink}
          to={item.href}
          selected={isSelected}
        >
        <ListItemIcon><item.icon /></ListItemIcon>
        <ListItemText primary={item.title} />
    </ListItemButton>
  );
}
